import { usePortalContext } from "./usePortalContext";
import { usePortalContexts } from "./usePortalContexts";

/**
 * Whether the caller holds `admin` on the current org — the same check
 * `orgAdminProcedure` makes. A Palomma `user.admin` without an org grant
 * reaches the org but is not an org admin.
 */
export function useIsOrgAdmin(): boolean {
  const { context } = usePortalContext();
  const { orgs } = usePortalContexts();

  if (context?.type !== "org") return false;
  const org = orgs.find((o) => o.id === context.id);
  return !!org?.roles.includes("admin");
}
